import { EmptyComponent } from "processhub-components-lib";

const EmptyPage = () => {
  return (
    <EmptyComponent>
      <a
        href="https://product-stage.processhub.ai/"
        rel="noopener noreferrer"
        className="btn"
      >
        Go to Saudi Map
      </a>
    </EmptyComponent>
  );
};

export default EmptyPage;
